import React from 'react';
import { Link } from 'react-router-dom';

export const TermsContent: React.FC = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 mb-6">Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">1. Geltungsbereich</h2>
      <p>
        Diese Nutzungsbedingungen gelten für die Nutzung der Plattform Beyond Pages (nachfolgend "Dienst" genannt), die von Beyond Pages (nachfolgend "Anbieter" genannt) betrieben wird. Mit der Registrierung und Nutzung des Dienstes akzeptieren Sie diese Nutzungsbedingungen.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">2. Leistungsbeschreibung</h2>
      <p>
        Beyond Pages ist eine Plattform zur Erstellung und Verwaltung von QR-Codes für die Buchbranche. Der Dienst ermöglicht:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Erstellung von QR-Codes für verschiedene Inhaltstypen (Websites, Spotify-Playlists, YouTube-Videos, PDFs, Multishop-Links, Autorenprofile, Leseproben)</li>
        <li>Verwaltung und Bearbeitung von QR-Codes</li>
        <li>Analyse von Scan-Statistiken</li>
        <li>Team-Zusammenarbeit bei kostenpflichtigen Plänen</li>
        <li>Integration mit Buchverwaltungssystemen</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">3. Registrierung und Vertragsschluss</h2>
      <p>
        3.1 Die Nutzung des Dienstes setzt eine Registrierung voraus. Die Registrierung ist nur volljährigen natürlichen Personen sowie juristischen Personen gestattet.
      </p>
      <p>
        3.2 Mit der Registrierung kommt ein Nutzungsvertrag zwischen Ihnen und dem Anbieter zustande.
      </p>
      <p>
        3.3 Sie sind verpflichtet, bei der Registrierung wahrheitsgemäße Angaben zu machen und diese aktuell zu halten.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">4. Nutzungsrechte und -pflichten</h2>
      <p>
        4.1 Sie erhalten ein nicht-exklusives, nicht übertragbares Recht zur Nutzung des Dienstes im Rahmen dieser Nutzungsbedingungen.
      </p>
      <p>
        4.2 Sie sind verantwortlich für:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Die Sicherheit Ihrer Zugangsdaten</li>
        <li>Alle Aktivitäten, die unter Ihrem Account stattfinden</li>
        <li>Die Rechtmäßigkeit der von Ihnen verlinkten Inhalte</li>
        <li>Die Einhaltung geltender Gesetze und Rechte Dritter</li>
      </ul>
      <p>
        4.3 Untersagt ist insbesondere:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Die Verlinkung rechtswidriger, beleidigender oder jugendgefährdender Inhalte</li>
        <li>Die Verwendung für Spam oder unerwünschte Werbung</li>
        <li>Der Versuch, den Dienst zu hacken oder zu manipulieren</li>
        <li>Die automatisierte Nutzung ohne ausdrückliche Genehmigung</li>
        <li>Die Weitergabe von Zugangsdaten an Dritte</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">5. Kostenpflichtige Leistungen</h2>
      <p>
        5.1 Der Dienst bietet verschiedene Preispläne an (Free, Starter, Professional, Enterprise).
      </p>
      <p>
        5.2 Die aktuellen Preise und Leistungsumfänge sind auf der Website einsehbar.
      </p>
      <p>
        5.3 Kostenpflichtige Pläne verlängern sich automatisch, sofern sie nicht fristgerecht gekündigt werden.
      </p>
      <p>
        5.4 Die Zahlung erfolgt im Voraus für den jeweiligen Abrechnungszeitraum.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">6. Verfügbarkeit</h2>
      <p>
        6.1 Der Anbieter bemüht sich um eine hohe Verfügbarkeit des Dienstes, kann diese jedoch nicht garantieren.
      </p>
      <p>
        6.2 Wartungsarbeiten werden nach Möglichkeit angekündigt.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">7. Haftung</h2>
      <p>
        7.1 Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit.
      </p>
      <p>
        7.2 Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den vorhersehbaren, vertragstypischen Schaden begrenzt.
      </p>
      <p>
        7.3 Die Haftung für Datenverlust ist auf den typischen Wiederherstellungsaufwand beschränkt.
      </p>
      <p>
        7.4 Der Anbieter haftet nicht für die Inhalte, auf die über QR-Codes verlinkt wird.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">8. Datenschutz</h2>
      <p>
        Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung, die unter <Link to="/privacy" className="text-blue-600 hover:text-blue-700">/privacy</Link> einsehbar ist.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">9. Laufzeit und Kündigung</h2>
      <p>
        9.1 Der kostenlose Plan kann jederzeit ohne Einhaltung einer Frist gekündigt werden.
      </p>
      <p>
        9.2 Kostenpflichtige Pläne haben eine Mindestlaufzeit entsprechend des gewählten Abrechnungszeitraums und können mit einer Frist von einem Monat zum Ende der Laufzeit gekündigt werden.
      </p>
      <p>
        9.3 Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
      </p>
      <p>
        9.4 Nach Kündigung werden Ihre Daten gemäß Datenschutzerklärung gelöscht.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">10. Änderungen der Nutzungsbedingungen</h2>
      <p>
        10.1 Der Anbieter behält sich vor, diese Nutzungsbedingungen zu ändern.
      </p>
      <p>
        10.2 Änderungen werden Ihnen per E-Mail mitgeteilt. Sie gelten als genehmigt, wenn Sie nicht innerhalb von vier Wochen widersprechen.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">11. Geistiges Eigentum</h2>
      <p>
        11.1 Alle Rechte am Dienst und seinen Inhalten liegen beim Anbieter.
      </p>
      <p>
        11.2 Sie räumen dem Anbieter die notwendigen Rechte ein, um Ihre Inhalte im Rahmen des Dienstes zu nutzen.
      </p>
      <p>
        11.3 Ihre Inhalte bleiben Ihr Eigentum.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">12. Schlussbestimmungen</h2>
      <p>
        12.1 Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
      </p>
      <p>
        12.2 Gerichtsstand für Kaufleute ist der Sitz des Anbieters.
      </p>
      <p>
        12.3 Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">13. Kontakt</h2>
      <p>
        Bei Fragen zu diesen Nutzungsbedingungen wenden Sie sich bitte an:<br />
        E-Mail: support@beyondpages.io
      </p>
    </div>
  );
};

export default TermsContent;

